import React from 'react';
import classNames from 'classnames/bind';
import { CategoryLandingPageSliderSection, ImageTransformation } from '@services';
import { ALL_IMAGES_TRANSFORMATIONS } from '@utils';
import styles from '../CategoryLandingPage.module.scss';
import { Carousel } from 'gd-design-library';

const CN = 'category-landing-page';
const sectionClassName = `${CN}__section`;
const sliderClassName = `${CN}__slider`;
const cx = classNames.bind(styles);

interface Props {
  section: CategoryLandingPageSliderSection;
}

export const Slider: React.FC<Props> = ({
  section: {
    slider: {
      slides
    }
  }
}) => {
  const imageTransformation = new ImageTransformation();

  return (
    <div className={ cx(sectionClassName, sliderClassName) }>
      <Carousel showArrows showDots>
        {slides.map(slide => (
          <Carousel.Image
            key={ slide.image?.[0]?.public_id }
            src={ imageTransformation.transformById(
              slide.image?.[0]?.public_id,
              ALL_IMAGES_TRANSFORMATIONS
            ) }
          />
        ))}
      </Carousel>
    </div>
  );
};
